// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-UserManagement-CreateUserDialog__main--imJIM","errorMessage":"---src-components-UserManagement-CreateUserDialog__errorMessage--Feyhw"};